import { Box } from '@mui/material'
import { sketcherSx } from './_styles'
import { Layer, Line, Stage } from 'react-konva'
import { BodyPartFemaleUrl, BodyPartMaleUrl } from '../../../assets/images/image'
import { TransmissionSketcherKonvaProps } from './_props'

export default function TransmissionSketcherKonva({
    strokes,
    stageSize,
    patientSex,
    onPointerDown,
    onPointerMove,
    onPointerUp,
    containerRef,
    stageRef,
    backgroundUrl,
    readOnly,
}: TransmissionSketcherKonvaProps) {
    const handleMouseDown = (event: any) => {
        if (readOnly) return
        event.evt.preventDefault()
        const stage = event.target.getStage()
        const pos = stage.getPointerPosition()
        if (!pos) return
        onPointerDown(pos)
    }

    const handleMouseMove = (event: any) => {
        if (readOnly) return
        event.evt.preventDefault()
        const stage = event.target.getStage()
        const point = stage.getPointerPosition()
        if (!point) return
        onPointerMove(point)
    }

    const handleMouseUp = () => {
        if (readOnly) return
        onPointerUp()
    }

    return (
        <Box ref={containerRef} sx={sketcherSx.sketchArea}>
            <img
                src={
                    backgroundUrl ?? (String(patientSex).toLowerCase() === 'femme' ? BodyPartFemaleUrl : BodyPartMaleUrl)
                }
                alt="Zone de dessin"
                style={{
                    width: '100%',
                    height: '100%',
                    // a drawing made on caregiver already contains the body and must not be cropped
                    objectFit: backgroundUrl ? 'contain' : 'cover',
                    borderRadius: 12,
                    position: 'absolute',
                    inset: 0,
                }}
            />
            <Stage
                ref={stageRef}
                width={stageSize.width}
                height={stageSize.height}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onTouchStart={handleMouseDown}
                onTouchMove={handleMouseMove}
                onTouchEnd={handleMouseUp}
                listening={!readOnly}
                style={{ position: 'absolute', inset: 0 }}
            >
                <Layer>
                    {strokes.map((line) => (
                        <Line
                            key={line.id}
                            points={line.points}
                            stroke="rgba(85, 90, 190, 0.70)"
                            strokeWidth={5}
                            tension={0.5}
                            lineCap="round"
                            lineJoin="round"
                            globalCompositeOperation={line.tool === 'eraser' ? 'destination-out' : 'source-over'}
                        />
                    ))}
                </Layer>
            </Stage>
        </Box>
    )
}
